import { Plus, Trash2, ArrowUp } from "lucide-react";
import { Field, GhostButton } from "./fields";
import ImageField from "./ImageField";

export default function GalleryEditor({ value = [], onChange }) {
  const update = (i, v) => onChange(value.map((x, j) => (j === i ? v : x)));
  const remove = (i) => onChange(value.filter((_, j) => j !== i));
  const moveUp = (i) => {
    if (i === 0) return;
    const next = [...value];
    [next[i - 1], next[i]] = [next[i], next[i - 1]];
    onChange(next);
  };

  return (
    <Field label={`Gallery (${value.length} images)`} hint="First image is used as the detail-page hero.">
      <div className="space-y-4">
        {value.map((src, i) => (
          <div key={i} className="flex items-start gap-3 border border-navy-ink/10 bg-white/40 p-3" data-testid={`yacht-form-gallery-${i}`}>
            <div className="flex-1">
              <ImageField label={`Image ${i + 1}`} value={src} onChange={(v) => update(i, v)} testId={`yacht-form-gallery-${i}`} aspect="aspect-[16/9]" />
            </div>
            <div className="flex flex-col gap-2 pt-6">
              <button type="button" onClick={() => moveUp(i)} className="p-1 text-mist hover:text-gold" aria-label="Move up" data-testid={`yacht-form-gallery-${i}-up`}><ArrowUp size={14} /></button>
              <button type="button" onClick={() => remove(i)} className="p-1 text-mist hover:text-red-700" aria-label="Remove" data-testid={`yacht-form-gallery-${i}-remove`}><Trash2 size={14} /></button>
            </div>
          </div>
        ))}
        {value.length < 16 && (
          <GhostButton type="button" onClick={() => onChange([...value, ""])} data-testid="yacht-form-add-gallery" className="inline-flex items-center gap-2"><Plus size={12} /> Add image</GhostButton>
        )}
      </div>
    </Field>
  );
}
